import {
  RESET_ASSESSMENT_REDIRECT_PATH,
  SET_ASSESSMENT_REDIRECT_PATH,
} from "../actions/actions-types";

const initialState = {
  redirectPath: "",
};

export const recoverAssessmentAccessReducer = (
  state = initialState,
  action
) => {
  if (action.type === SET_ASSESSMENT_REDIRECT_PATH) {
    return {
      ...state,
      redirectPath: action.payload,
    };
  }

  if (action.type === RESET_ASSESSMENT_REDIRECT_PATH) {
    return {
      ...state,
      redirectPath: "",
    };
  }

  return state;
};
